import Pipeline from "../Pipeline";
import { UserActionReportReq, UserActionReportRsp } from "../actionTypes";
import { ActionResult } from "../types";
import config from "../config";

export default class EndHook extends Pipeline<
    ActionResult<UserActionReportRsp>
> {
    private enabled = false;

    constructor() {
        super();

        this.enabled = config.success;
    }

    private actionType(action: UserActionReportReq): number {
        return (
            action.report_infos[0] &&
            action.report_infos[0].page_info.item_infos[0] &&
            action.report_infos[0].page_info.item_infos[0].action_infos[0] &&
            action.report_infos[0].page_info.item_infos[0].action_infos[0]
                .action_id
        );
    }

    set enable(flag: boolean) {
        this.enabled = flag;
    }

    get enable(): boolean {
        return this.enabled;
    }

    process(
        ar: ActionResult<UserActionReportRsp>
    ): Promise<ActionResult<UserActionReportRsp>> {
        if (this.enabled === true) {
            const action: UserActionReportReq = JSON.parse(ar.action.content);

            // 直接通过report接口上报的没有target
            if (ar.action.target) {
                const type: number = this.actionType(action);

                const evt: Event = new Event("vtrackerEnd");

                evt["data"] = {
                    type,
                    action
                };

                ar.action.target.dispatchEvent(evt);
            }
        }

        return Promise.resolve(ar);
    }
}
